import { Inject, Injectable } from "@angular/core";
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwOrmDataService, DwOrmDataServiceToken, DwQuery, DwUserEntity } from "@devwareapps/devware-cap";
import { AcsTestEntity, AppMetaData, AppMetaDataItemNames, CheckRideRequestEntity, FlightSchoolApplicantEntity, PilotExaminerEntity } from "../../../meta-data/app-meta-data.service";
import { ExaminerRepositoryService } from "../../examiner/services/examiner-repository.service";

@DwCustomContextDefinition({
    keyName: 'checkride-test-type-context',
    display: 'Checkride Test Type Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.CheckRideRequest,
})
@Injectable()
export class CheckrideTestTypeContextService extends DwCustomContextBase {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        private examinerRepositoryService: ExaminerRepositoryService
    ) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext, contextData) => {
            const testTypeId = this.getTestTypeId(resolvedContext);

            if (!testTypeId) {
                return null;
            }

            return this.examinerRepositoryService.getCheckrideTestType(testTypeId);
        };

        contextDef.item = AppMetaDataItemNames.CheckRideTestType;
        contextDef.getCustomContextKey = (resolvedContext) => {
            return this.getTestTypeId(resolvedContext);
        };

        contextDef.useItemMetaData = true;
    }

    getTestTypeId(resolvedContext: any) {
        const checkrideRequest: CheckRideRequestEntity = resolvedContext?.data;
        return checkrideRequest?.CheckRideTestTypeId;

    }
} 